// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import {
  optionsFetchBadgetTeamPublic,
  optionsFetchSearchTeamByNameAndTag,
  optionsFetchTeamByIdPublic,
  optionsFetchTeamMembersByIdPublic,
  optionsFetchTeamPerformanceStatsPublic,
} from "@/config/plugins/queryOptions.reactquery.ts";
import { FileBussinessType } from "@/integration/application/interfaces/file.interface.ts";
import { ISearchPagination } from "@/integration/application/interfaces/searchPagination.interface.ts";

interface TeamPublic {
  entity: any;
  files: any[];
}

interface DataStatsTeam {
  upcomingMatches: any[];
  previusMatches: any[];
  teamResults: {
    wins: number;
    losses: number;
  };
}

const useTeamPublic = (teamId?: string) => {
  const enabled = Boolean(teamId);

  const { data: teamData } = useQuery({
    ...optionsFetchTeamByIdPublic(teamId!),
    enabled,
  });

  const team = teamData as TeamPublic;

  const files = team?.files || [];

  const avatarFile = useMemo(() => {
    return files.find(
      (item: any) => item.business_type === FileBussinessType.TEAM_PROFILE_PHOTO
    );
  }, [files]);

  const bannerFile = useMemo(() => {
    return files.find(
      (item: any) => item.business_type === FileBussinessType.TEAM_BANNER_PHOTO
    );
  }, [files]);

  const { data: teamMembers } = useQuery({
    ...optionsFetchTeamMembersByIdPublic(teamId!),
    enabled,
  });

  const { data: dataStatsTeamData } = useQuery({
    ...optionsFetchTeamPerformanceStatsPublic(teamId!),
    enabled,
  });

  const dataStatsTeam = dataStatsTeamData as DataStatsTeam;

  const { data: badgetsTeam } = useQuery({
    ...optionsFetchBadgetTeamPublic(teamId!),
    enabled,
  });

  const searchTeamByNameAndTag = (searchPagination: ISearchPagination) => {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ("searchTeamByNameAndTag", searchPagination);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = useQuery({...optionsFetchSearchTeamByNameAndTag(searchPagination)});
    return { data };
  };

  return {
    entity: team?.entity,
    files: team?.files,
    avatarFile,
    bannerFile,
    teamMembers,
    upcomingMatches: dataStatsTeam?.upcomingMatches || [],
    previusMatches: dataStatsTeam?.previusMatches || [],
    countWnnersTeam: dataStatsTeam?.teamResults?.wins || 0,
    countDefeatsTeam: dataStatsTeam?.teamResults?.losses || 0,
    badgetsTeam,
    searchTeamByNameAndTag
  };
};

export default useTeamPublic;
